module.exports = __webpack_public_path__ + "static/media/NotesPdf.82eb4fc5.txt";